import axios from './axios';

export { axios };

export const request = (params) =>
  new Promise((resolve, reject) => {
    // console.log('---axios-paramas--->', params);
    axios.request(params).then((response) => {
      resolve(response.data);
    }, reject);
  });
